export const LOCAL_KTX2_TRANSCODER_PATH = "/basis/";
